module.exports = __webpack_public_path__ + "img/logo-ecartpay.b18635e2.svg";